import { Routes } from '@angular/router';
import { NotFoundComponent } from './_pages/not-found/not-found.component';
import { CombinedMainGuard } from './global/guards/combined-main.guard';
import { AuthGuard } from './global/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        canActivate: [AuthGuard],
        loadComponent: () => import('./_pages/login/login.component').then(mod => mod.LoginComponent)
    },
    {
        path: 'change',
        loadComponent: () => import('./_pages/change/change.component').then(mod => mod.ChangeComponent)
    },
    {
        path: 'public-rfq',
        loadComponent: () => import('./_pages/public-rfq/public-rfq.component').then(mod => mod.PublicRfqComponent)
    },
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: '',
        canActivate: [CombinedMainGuard],
        pathMatch: 'prefix',
        loadComponent: () => import('./_pages/organizer/organizer.component').then(mod => mod.OrganizerComponent),
        loadChildren: () => import('./_pages/organizer/organizer.routes').then(m => m.ORGANIZER_ROUTES)
    },
    {
        path: '**',
        redirectTo: '404'
    }
];
